<template>
  <transition name="fade">
    <div class="limited-time-record-popup" v-if="visible">
      <div class="record-popup">
        <p class="dialog-title">{{ letter.limitedTimeActivityRecord }}</p>
        <div class="record-container">
          <table class="record-table">
            <thead>
              <tr>
                <th>{{ letter.limitedTimeActivityAward }}</th>
                <th>{{ letter.limitedTimeActivityGotRole }}</th>
                <th>{{ letter.limitedTimeActivityGotTime }}</th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr v-for="(item, index) in record" :key="index">
                <td>{{ item.awardDetail }}</td>
                <td>{{ item.role_name }}</td>
                <td>{{ item.time }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <Button class="close-btn" @click="hidePopup"></Button>
      </div>
      <PopupWindow
        v-if="showTipPopup"
        type="tips"
        :languages="letter"
        :content="popupTip"
        textAlign="center"
        @onConfirm="showTipPopup = false"
        @onCancel="showTipPopup = false"
      ></PopupWindow>
    </div>
  </transition>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import { UPDATE_LOADING } from '@store/officialStore';
import { LIMITED_TIME_ACTIVITY_AWARD_LOG } from '@store/officialStore/event';
import { clickButton, locationType } from '@plugins/biPoint/_configWebstoreV1';
export default {
  name: 'LimitedTimeRecordPopup',
  props: ['visible'],
  data() {
    return {
      record: [],
      showTipPopup: false,
      popupTip: ''
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      letter: state => state.letter,
      showCurrency: state => state.showCurrency
    }),
    ...mapGetters(['gameInfoConfig']),
    limitedTimeActivityAwardList() {
      return this.gameInfoConfig.limitedTimeActivity.awardList;
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getRecord();
      }
    }
  },
  methods: {
    async getRecord() {
      try {
        this.$store.commit(UPDATE_LOADING, true);
        const res = await this.$store.dispatch(
          LIMITED_TIME_ACTIVITY_AWARD_LOG,
          {
            currency: this.showCurrency
          }
        );
        this.record = res.data?.map(record => {
          return {
            ...record,
            awardDetail:
              this.limitedTimeActivityAwardList[record.id].awardDetail[
                this.lang
              ] ||
              this.limitedTimeActivityAwardList[record.id].awardDetail[
                'default'
              ]
          };
        });
      } catch (err) {
        console.log(err);
        this.popupTip = `[${err.code}] ${this.letter.limitedTimeActivityWrongParam}`;
        this.showTipPopup = true;
      } finally {
        this.$store.commit(UPDATE_LOADING, false);
      }
    },
    hidePopup() {
      this.$emit('onClose');
      clickButton({
        btnName: 'close_eventsbag',
        locationKey: locationType.eventsBagPopup
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.limited-time-record-popup {
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 101;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);

  .record-popup {
    position: relative;
    background-size: 100% 100%;
    @psetbg ('common-popup.png');

    .record-container {
      display: inline-block;
      position: relative;
      margin: 0 42px;
      height: 320px;
      overflow-y: scroll;
      border: solid 1px var(--global-tip-popup-text);

      &::-webkit-scrollbar {
        display: none;
      }
      .record-table {
        width: 100%;
        padding: 0 42px;
        table-layout: fixed;
        border-collapse: collapse;

        thead {
          top: 0;
          position: sticky;
          outline: solid 1px var(--global-tip-popup-text);
          border: solid 1px var(--global-tip-popup-text);
          background-color: var(--limited-time-activity-table-header);
        }
        th {
          padding: 20px;
          text-align: center;
          font-size: 26px;
          color: var(--global-tip-popup-text);
          border: solid 1px var(--global-tip-popup-text);
        }
        td {
          padding: 20px;
          border: solid 1px var(--global-tip-popup-text);
          text-align: center;
          font-size: 22px;
          line-height: 30px;
          word-break: break-word;
          color: var(--global-tip-popup-text);
        }
      }
    }

    .close-btn {
      position: absolute;
      @psetbg ('close.png');
    }
  }
}
</style>
